export enum AllowedPages {
    CardTraffic = 1,
    OpenItems,
    Readings,
    ReserveFund,
    ManagerDocuments,
    SupplierDocuments,
    Notifications,
    YourUnits,
    BulletinBoard,
    Faq,
    Contractors,
    ReservedFundDebtors,
    ReservedFundPostings,
    CostSpecification,
    Tenants,
    RegularBilling,
    ReserveFundBilling,
    VoluntaryFund,
    RegisteredNumberOfPeopleAndDogs,
    InsuranceContracts
}

export enum InternalPages {
    Login = 100,
    Register,
    ForgottenPassword,
    ResetPassword,
    AddManager,
    LoginAsUser,
    Home,
    Profil,
    Forms
}
